import { PhoneCall, FileSearch, Handshake, BadgeCheck } from "lucide-react";

const STEPS = [
  {
    icon: PhoneCall,
    title: "Tell us what happened",
    description: "Call us or submit our 60-second form. We listen, gather basic details, and answer your immediate questions.",
  },
  {
    icon: FileSearch,
    title: "We match you to the right attorney",
    description: "Based on your accident type, location, and situation, we connect you with the best Pennsylvania attorney for your case.",
  },
  {
    icon: Handshake,
    title: "Free, no-obligation consultation",
    description: "Talk directly with the attorney. They review your case, explain your options, and answer every question — at no cost.",
  },
  {
    icon: BadgeCheck,
    title: "You decide what's next",
    description: "If you hire them, they work on contingency — you pay nothing unless they win. If not, you walk away owing nothing.",
  },
];

export default function HowItWorks() {
  return (
    <section className="section bg-bone" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="overline mb-3">How It Works</div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-forest tracking-tight mb-4 text-balance">
            Four simple steps. Zero obligation.
          </h2>
          <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">
            We've made getting help as straightforward as possible. No legalese. No pressure.
            Just a clear path from "what do I do?" to "I have someone in my corner."
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, idx) => (
            <div
              key={idx}
              className="relative card-clay p-6 md:p-7"
              data-testid={`how-step-${idx + 1}`}
            >
              <div className="absolute -top-3 -left-3 w-8 h-8 rounded-full bg-terracotta text-white grid place-items-center font-display font-black text-sm">
                {idx + 1}
              </div>
              <div className="w-11 h-11 rounded-xl bg-forest/5 text-forest grid place-items-center mb-4">
                <s.icon className="w-5 h-5" />
              </div>
              <h3 className="font-display font-bold text-lg md:text-xl text-forest mb-2 leading-tight">
                {s.title}
              </h3>
              <p className="text-sm md:text-base text-charcoal-soft leading-relaxed">
                {s.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
